__turbopack_context__.v({
  "Date": "Post-module__c2QGoW__Date",
  "DateMobile": "Post-module__c2QGoW__DateMobile",
  "SingleArticlePage": "Post-module__c2QGoW__SingleArticlePage",
  "dealsPageFullWidth": "Post-module__c2QGoW__dealsPageFullWidth",
  "mobileSocialShare": "Post-module__c2QGoW__mobileSocialShare",
  "post-subtitle": "Post-module__c2QGoW__post-subtitle",
  "post-title": "Post-module__c2QGoW__post-title",
  "promoted": "Post-module__c2QGoW__promoted",
  "readnext": "Post-module__c2QGoW__readnext",
  "separator--promoted": "Post-module__c2QGoW__separator--promoted",
  "single-article-info": "Post-module__c2QGoW__single-article-info",
  "singleArticleHero": "Post-module__c2QGoW__singleArticleHero",
  "socialshare": "Post-module__c2QGoW__socialshare",
  "tagsContainer": "Post-module__c2QGoW__tagsContainer",
});
